var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1065_3583)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5841 90.9476L111.958 103.322L114.08 101.201L101.705 88.8263L114.08 76.4519L111.958 74.3306L99.5841 86.705L87.2097 74.3306L85.0884 76.4519L97.4628 88.8263L85.0884 101.201L87.2097 103.322L99.5841 90.9476Z",
    fill: "#59BD39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2219 137.033C85.3651 154.242 118.232 153.387 140.662 133.362C166.299 110.476 168.596 71.2154 145.792 45.6717C122.988 20.1279 83.7196 17.9738 58.083 40.8604C39.2517 57.6716 33.0137 83.3177 40.0668 105.873C41.9038 111.747 44.6424 117.412 48.295 122.656",
    stroke: "#1B1B1B",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07 129.691L168.742 155.999",
    stroke: "#1B1B1B",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1065_3583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export default ForwardRef;